const EmptyState = ({ icon: Icon, title, subtitle, action }) => (
  <div
    className="flex flex-col items-center justify-center text-center"
    style={{ padding: "48px 24px" }}
  >
    {Icon && (
      <div
        className="flex items-center justify-center w-12 h-12 rounded-full mb-4"
        style={{
          backgroundColor: "var(--lm-s2)",
          border: "1px solid var(--lm-border)",
        }}
      >
        <Icon className="w-5 h-5" style={{ color: "#5e6ad2" }} />
      </div>
    )}
    <p
      className="font-medium mb-1"
      style={{ color: "var(--lm-ink)", fontSize: "14px" }}
    >
      {title}
    </p>
    {subtitle && (
      <p style={{ color: "var(--lm-ink-2)", fontSize: "13px", maxWidth: "320px" }}>
        {subtitle}
      </p>
    )}
    {action && (
      <button
        onClick={action.onClick}
        className="mt-4 px-4 py-2 rounded-lg text-sm font-medium transition-colors"
        style={{
          backgroundColor: "#5e6ad2",
          color: "#ffffff",
          border: "none",
          cursor: "pointer",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#828fff")}
        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#5e6ad2")}
      >
        {action.label}
      </button>
    )}
  </div>
);

export default EmptyState;
